import React, { useEffect } from "react";
import styles from "../blogPage/blogPage.module.scss";
import blogImg from "../../assests/blogImg.png";
import blogBaseImg from "../../assests/blogBaseImg.png";
import BlogCard from "../../components/blogCard/BlogCard";
import Navbar from "../../components/navbar/Navbar";
import blogCardProfile from "../../assests/blogCardProfile.png";
import Footer from "../footer/Footer";


const BlogPage = () => {
  useEffect(() => {
    const section = document.getElementById("blogTop");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <div className={styles.container}>
      <Navbar />
      <div className={styles.wrapper}>
        <div className={styles.topBlog} id="blogTop">
          <div className={styles.blogTop}>
            <div className={styles.blogTopLeft}>
              <img src={blogImg} alt="" className={styles.blogImg} />
            </div>
            <div className={styles.blogTopRight}>
              <div className={styles.head}>
                Financial Tips and News on Our Official Blog
              </div>
              <div className={styles.description}>
                Creating and sticking to a budget is essential for achieving
                financial stability and reaching your financial goals. Whether
                you're saving for a big purchase, paying off debt, or just
                trying to manage your day-to-day expenses, a well-planned budget
                can make all the difference. In this blog post, we'll walk you
                through top tips for effective financial planning and how you
                can use megam to streamline the process.
              </div>
              <div className={styles.bottomProfile}>
                <div className={styles.profileRight}>
                  <img
                    src={blogCardProfile}
                    alt=""
                    className={styles.blogProfileImg}
                  />
                  <div className={styles.name}>Jenny Wilson</div>
                </div>
                <div className={styles.profileLeft}>Jan 10, 2024</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.middleBlog}>
          <div className={styles.middleBlogTop}>
            <div className={styles.head}>
              Mastering Your Budget: Top Tips for Effective Financial Planning
            </div>
            <div className={styles.description}>
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
            <div className={styles.description}>
              Keep a detailed record of all your sources of income and expenses.
              This will give you a clear picture of where your money is going.
            </div>
          </div>
          <div className={styles.middleBlogMiddle}>
            <div className={styles.head}>Track Your Income and Expenses</div>
            <div className={styles.description}>
              <li>
                Record Everything: Keep a detailed record of all your sources of
                income and expenses. This will give you a clear picture of where
                your money is going.
              </li>
              <li>
                Automate Tracking with Savi: Savi automatically categorizes your
                transactions and provides real-time updates on your spending,
                saving you time and ensuring accuracy.
              </li>
              <li>
                Review Regularly: Make it a habit to review your financial
                activity weekly or monthly to ensure you're staying on track.
              </li>
              <li>
                Break Down Expenses: Divide your spending into categories such
                as housing, utilities, groceries, entertainment, and savings.
              </li>
              <li>
                Identify Patterns: Look for patterns in your spending to
                identify areas where you might be overspending.
              </li>
              <li>
                Customizable Categories in Savi: Savi allows you to create
                custom categories and reassign transactions, providing a
                tailored budgeting experience.
              </li>
            </div>
          </div>
        </div>
        <div className={styles.blogBaseImg}>
          <img src={blogBaseImg} alt="" />
        </div>
        <div className={styles.budgetContent}>
          <div className={styles.head}>Recreate a Realistic Budget</div>
          <div className={styles.description}>
            <div>
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
            <div>
              Keep a detailed record of all your sources of income and expenses.
              This will give you a clear picture of where your money is going.
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. Creating and sticking to a budget is essential
              for achieving financial stability and reaching your financial
              goals. Whether you're saving for a big purchase, paying off debt,
              or just trying to manage your day-to-day expenses, a well-planned
              budget can make all the difference. In this blog post, we'll walk
              you through top tips for effective financial planning and how you
              can use Savi to streamline the process.
            </div>
            <div>
              Keep a detailed record of all your sources of income and expenses.
              This will give you a clear picture of where your money is going.
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
          </div>
        </div>
        <div className={styles.rule}>
          <div className={styles.head}>Implement the 50/30/20 Rule</div>
          <div className={styles.description}>
            <div>
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
            <div>
              Keep a detailed record of all your sources of income and expenses.
              This will give you a clear picture of where your money is going.
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
          </div>
        </div>
        <div className={styles.conclusion}>
          <div className={styles.head}>Conclusion</div>
          <div className={styles.description}>
            <div>
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
            <div>
              Keep a detailed record of all your sources of income and expenses.
              This will give you a clear picture of where your money is going.
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use Savi to
              streamline the process.
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.title}>Read more blogs like this</div>
          <div className={styles.subTitle}>
            Optimize your savings with PennyPerfect. Track expenditures, save
            smartly with this straightforward app.
          </div>
          <div className={styles.cardContainer}>
            <BlogCard />
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default BlogPage;
